exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gh-img[data-v-3df94162]{display:flex;justify-content:center;align-items:center;padding:2rem 0}img[data-v-3df94162]{width:100px;height:100px}.v-card__title[data-v-3df94162]{justify-content:center;font-size:1.8rem!important}.gh-message[data-v-3df94162]{font-size:1.5rem;margin:2rem 0;text-align:center;line-height:1.7}", ""]);

// exports
